import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActionPlanModel } from '../../shared/models/index';

@Component({
    selector: 'action-plan-list-table',
    templateUrl: './list.component.html',
    standalone: false
})
export class ActionPlanListComponent {
  @Input() public actionPlans: ActionPlanModel[];
  @Output() public toggleSelectActionPlan: EventEmitter<any> = new EventEmitter();
  public selection: any = {};
  errorMessage: string;
  orderByFieldName = 'name';
  direction = 'asc';
  @Input() query = '';

  constructor() {}

  public selectActionPlan(actionPlan: ActionPlanModel) {
    this.toggleSelectActionPlan.emit(actionPlan);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }
}
